export default __webpack_public_path__ + "static/media/bg_1970.1fcd55c8.png";